export const PROFILE_LINK = '/profile'